import { render, staticRenderFns } from "./RequestsNew.vue?vue&type=template&id=005c10b1&scoped=true"
import script from "./RequestsNew.vue?vue&type=script&lang=js"
export * from "./RequestsNew.vue?vue&type=script&lang=js"
import style0 from "./RequestsNew.vue?vue&type=style&index=0&id=005c10b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c10b1",
  null
  
)

export default component.exports